export const INITIALS_PREFIX = 'initials';

export const WITHHOLDING_AFFIX = 'withholding';

export default INITIALS_PREFIX;
